import request from "@helpers/request";

function fetchKpi(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/kpi`, {}, { ...config });
}
function fetchKpiFilterR(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/kpi/${params.operator}/${params.tech}`, {}, { ...config });
}
function fetchKpiFilter(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/kpi/${params.tech}`, {}, { ...config });
}
function createKpi(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/kpi`, params, { ...config });
}

function deleteKpi(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .delete(`/v1/kpi`, params, { ...config });
}
const baseUrl = "/v1/kpi";
function Post(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function Get(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config });
}
function PostBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
function GetBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
const kpiService = {
  Get,
  Post,
  PostBlob,
  GetBlob,
  fetchKpi,
  createKpi,
  deleteKpi,
  fetchKpiFilter,
  fetchKpiFilterR
};

export default kpiService;
